/// ///////////////////////////////////////////////////////////////////////////
//  Copyright (C) 2013 by sanpolo CO.LTD                                    //
//                                                                          //
//  This file is part of WIDE                                               //
//                                                                          //
//  You should have received a copy of the WIDE License along with this     //
//  program.  If not, see <http://www.wware.org/wide/license.html>.         //
//                                                                          //
//  WIDE website: http://www.wware.org/                                     //
/// ///////////////////////////////////////////////////////////////////////////
// Created At : 2019-01-25T10:13:45.465Z by lizhutang (lizhutang@spolo.org)

'use strict'

import loadTraits from './traits'
import loadComponents from './components'
import loadBlocks from './blocks'
import loadDevices from './devices'
import loadCommands from './commands'

/**
bootstrap 4的grapesjs插件，借鉴了[grapesjs-blocks-bootstrap4](https://github.com/z1lk/grapesjs-blocks-bootstrap4).
@module bs4
*/

export default (editor, opts = {}) => {
  const optsBlocks = opts.blocks || {}
  const optsLabels = opts.labels || {}
  const optsCategories = opts.blockCategories || {}
  const defaultBlocks = {
    default: true,
    text: true,
    link: true,
    image: true,
    // LAYOUT
    container: true,
    row: true,
    column: true,
    column_break: true,
    media_object: true,
    // COMPONENTS
    alert: true,
    badge: true,
    button: true,
    button_group: true,
    button_toolbar: true,
    card: true,
    card_container: true,
    collapse: true,
    dropdown: true,
    // TYPOGRAPHY
    header: true,
    paragraph: true,
    // BASIC
    list: true
  }

  const defaultLabels = {
    // LAYOUT
    container: '行列容器',
    row: '行',
    column: '列',
    column_break: '换行列',
    media_object: 'Media Object',
    // COMPONENTS
    alert: 'Alert',
    badge: 'Badge',
    button: 'Button',
    button_group: 'Button Group',
    button_toolbar: 'Button Toolbar',
    card: 'Card',
    card_container: 'Card Container',
    collapse: 'Collapse',
    dropdown: 'Dropdown',
    dropdown_menu: 'Dropdown Menu',
    dropdown_item: 'Dropdown Item',
    // TYPOGRAPHY
    text: 'DIV容器',
    header: '标题',
    paragraph: '文本段',
    // BASIC
    image: '图像',
    link: '链接',
    list: 'Simple List'
  }

  const defaultCategories = {
    'layout': true,
    'components': true,
    'typography': true,
    'extension': true,
    'basic': true
  }

  let options = { ...{
    blocks: Object.assign(defaultBlocks, optsBlocks),
    labels: Object.assign(defaultLabels, optsLabels),
    blockCategories: Object.assign(defaultCategories, optsCategories),
    gridDevices: true,
    gridDevicesPanel: true
  },
  ...opts }

  // Add components
  loadCommands(editor, options)
  loadTraits(editor, options)
  loadComponents(editor, options)
  loadBlocks(editor, options)
  loadDevices(editor, options)

  // TODO Remove
  // editor.on('load', () => editor.addComponents(`<div style="margin:0 100px; padding:25px;">Content loaded from the plugin</div>`))
}
